import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { S3CompatibleAdditionalOptionsComponent } from '@components/storage-accounts/add-storage-account-wizard/credential-forms/s3-compatible-additional-options/s3-compatible-additional-options.component';
import { AlertComponent, MbsPopupType } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';

@Component({
  selector: 'mbs-s3-compatible-advanced-settings-step',
  templateUrl: './s3-compatible-advanced-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AlertComponent, S3CompatibleAdditionalOptionsComponent]
})
export class S3CompatibleAdvancedSettingsComponent {
  protected readonly StorageType = StorageType;
  protected readonly MbsPopupType = MbsPopupType;

  @Input() form: FormGroup;
  @Input() isNativeMultipartControlShown = false;
  @Input() error: string;
}
